import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';

/** Banner card: same height as Dealer card (230px). Expands to fill row when space available; min 288px. */
export const BannerCardWrapStyled = styled.div`
  position: relative;
  z-index: 1;
  min-width: 288px;
  height: 230px;
  min-height: 230px;
  max-height: 230px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  flex: 1 1 288px;
  display: flex;
  flex-direction: column;
  overflow: visible;

  /* Tablet/mobile: full width when stacked above Dealer card */
  @media screen and (max-width: 768px) {
    height: auto;
    min-height: 0;
    max-height: none;
    width: 100%;
    flex: 1 1 auto;
  }
  @media screen and (max-width: 424px) {
    height: auto;
    min-height: 0;
    max-height: none;
    width: 100%;
    flex: 1 1 auto;
  }

  /* InfoCard fills wrapper; inner content stretches to fill; fixed width so card does not shrink with short messages */
  & > div {
    flex: 1;
    min-height: 0;
    height: 100%;
    max-height: 100%;
    width: 100%;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow: visible;
  }

  /* Mobile: accordion shrinks to content when collapsed; no flex grow */
  @media screen and (max-width: 768px) {
    & > div {
      height: auto;
      max-height: none;
      flex: 0 0 auto;
      align-self: flex-start;
    }
  }
  @media screen and (max-width: 424px) {
    & > div {
      height: auto;
      max-height: none;
      flex: 0 0 auto;
      align-self: flex-start;
    }
  }
`;

/** Vertically stacked messages container; scrollable when overflow. */
export const MessagesStackStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  width: 100%;
  padding-right: 12px;
`;

/** Inner column: message content fills card. */
export const BannerContentWrapStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  align-items: stretch;
`;

/** Bubble: light blue background (light theme), dark blue-gray (dark theme); theme-aware colors. */
export const MessageBubbleStyled = styled(FlexContainer)<{ $stackItem?: boolean }>`
  flex: ${({ $stackItem }): string => ($stackItem ? '0 0 auto' : '1')};
  min-width: 0;
  min-height: 0;
  padding: 8px 10px;
  border-radius: 8px;
  /* Light: WarrQueue workItemType.info; Dark: readable info-style bubble */
  background-color: ${({ theme }): string =>
    theme.mode === 'dark' ? theme.colors.highlight.variant6 : '#E5F6FD'};
  border: ${({ theme }): string =>
    `1px solid ${theme.mode === 'dark' ? theme.colors.primary.variant5 : '#CED4DA'}`};
  box-sizing: border-box;
  color: ${({ theme }): string =>
    theme.mode === 'dark' ? theme.colors.primary.variant11 : '#014361'};
  overflow-y: ${({ $stackItem }): string => ($stackItem ? 'visible' : 'auto')};
  align-items: flex-start;

  /* Message text can wrap within the card */
  & > *:last-child {
    min-width: 0;
    word-break: break-word;
    white-space: normal;
  }

  /* Ensure text is white in dark theme (Typography/links may override inherit) */
  ${({ theme }): string =>
    theme.mode === 'dark'
      ? `
    &, & *, & a {
      color: ${theme.colors.white} !important;
    }
  `
      : ''}
`;
